import { Badge, Box, Stack, Typography } from "@mui/material";

import { useContext, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import LogIcon from "../../Assets/Icons/Log.svg";
import QRIcon from "../../Assets/Icons/QR.svg";
import { ColorScheme } from "../../Themes/ColorScheme";
import { MuiDrawer } from "../Common/MuiDrawer";
import TooltipWrapper from "../Common/TooltipWrapper";
import { UserContext } from "../UserContext";

import { ListDoorUsers } from "./ListDoorUsers";

import { DoorLogs } from "./DoorLogs";

import { ReactComponent as NewUserIcon } from "../../Assets/Icons/UserIcon.svg";
import LandingAnimation from "../../Helpers/LandingAnimation";
import { ModifyDoor } from "./ModifyDoor";

export const DoorCard = ({ data, fetchDoors, newRequests }) => {

	const [drawerContent, setDrawerContent] = useState(null);

	const { t } = useTranslation();
	const { selectedLocation } = useContext(UserContext);

	const handleDrawerClose = () => {
		setDrawerContent(null);
		fetchDoors();
	};

	return (
		<LandingAnimation>
			<div>
				<Stack
					onClick={(event) => {
						event.stopPropagation();
						event.preventDefault();
						setDrawerContent({
							content: <ModifyDoor content={data} handleDrawerClose={handleDrawerClose}/>,
							title: t("doors.door_info"),
							subtitle: data.name
						});
					}}
					direction="row"
					sx={{
						width: isMobile ? undefined : "350px",
						boxSizing: "border-box",
						display: "flex",
						flexDirection: "column",
						backgroundColor: ColorScheme.secondary,
						borderRadius: "4px",
						alignItems: "center",
						justifyContent: "space-between",
						padding: "20px",
						color: ColorScheme.black,
						transition: ".3s",
						overflow: "hidden",
						cursor: "pointer",
						gap: "25px",
						"&:hover": {
							scale: "1.01"
						}
					}}
				>
					<div
						style={{
							flexDirection: "row",
							display: "flex",
							justifyContent: "space-between",
							width: isMobile ? "95%" : "100%",
							alignItems: "center"
						}}
					>
						<Box
							style={{
								height: "100%",
								flexDirection: "row",
								display: "flex",
								alignItems: "center",
								width: "100%",
								justifyContent: "space-between"
							}}
						>
							<Box
								sx={{
									flexDirection: "column",
									display: "flex"
								}}
							>
								<Typography
									style={{
										fontSize: "24px",
										fontWeight: "700"
									}}
								>
									{data.name}
								</Typography>
								<Typography
									style={{
										fontSize: "16px",
										fontWeight: "700",
										color: ColorScheme.textSecondary
									}}
								>
									{data?.phone || t("doors.no_doorphone")}
								</Typography>
							</Box>

							<TooltipWrapper
								ignoreStringRestriction={true}
								title={
									<>
										{data.online
											? t("doors.door_online")
											: t("doors.door_offline")}
									</>
								}
							>
								<Box
									sx={{
										height: "16px",
										width: "16px",
										borderRadius: "8px",
										background: data.online
											? ColorScheme.green
											: ColorScheme.red
									}}
								/>
							</TooltipWrapper>
						</Box>
					</div>

					<div
						style={{
							backgroundColor: ColorScheme.lightGrey,
							borderRadius: "4px",
							padding: "20px",
							width: isMobile ? "70dvw" : "85%",
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between"
						}}
					>
						<TooltipWrapper title={t("doors.show_userlist")}>
							<Box
								style={{
									flexDirection: "column",
									justifyContent: "center",
									display: "flex",
									alignItems: "center",
									cursor: "pointer"
								}}
								onClick={(event) => {
									event.stopPropagation();
									event.preventDefault();
									setDrawerContent({
										content: <ListDoorUsers door={data} />,
										title: t("doors.access_rights"),
										subtitle: data.name
									});
								}}
							>
								{
									<Badge
										badgeContent={newRequests}
										color="error"
										anchorOrigin={{
											vertical: "top",
											horizontal: "left"
										}}
										sx={{ mx: "10px" }}
									/>
								}
								<NewUserIcon
									height={"28px"}
									width={"28px"}
									stroke={ColorScheme.black}
									strokeWidth={"2px"}
								/>
								<Typography
									style={{
										fontSize: "12px",
										color: ColorScheme.darkGrey,
										fontWeight: "500",
										marginTop: "5px"
									}}
								>
									{data.user_count}
								</Typography>
							</Box>
						</TooltipWrapper>
						{!selectedLocation.location_permissions.some(
							(check) => check.permission_id === 6
						) && (
							<TooltipWrapper title={t("logs.show_access_logs")}>
								<Box
									style={{
										flexDirection: "column",
										justifyContent: "center",
										display: "flex",
										alignItems: "center",
										cursor: "pointer"
									}}
									onClick={(event) => {
										event.stopPropagation();
										setDrawerContent({
											content: <DoorLogs doorData={data} />,
											title: t("doors.access_logs"),
											subtitle: data.name
										});
									}}
								>
									<img
										style={{ height: "30px" }}
										src={LogIcon}
									/>
									<Typography
										style={{
											fontSize: "12px",
											color: ColorScheme.darkGrey,
											fontWeight: "500",
											marginTop: "5px"
										}}
									>
										{t("buttons.log_events")}
									</Typography>
								</Box>
							</TooltipWrapper>
						)}
						<Box
							style={{
								flexDirection: "column",
								justifyContent: "center",
								display: "flex",
								alignItems: "center"
							}}
						>
							<img style={{ height: "30px" }} src={QRIcon} />
							<Typography
								style={{
									fontSize: "12px",
									color: ColorScheme.darkGrey,
									fontWeight: "500",
									marginTop: "5px"
								}}
							>
								{data.code}
							</Typography>
						</Box>
					</div>
				</Stack>
				<MuiDrawer
					open={drawerContent != null}
					handleDrawerClose={handleDrawerClose}
					subview={drawerContent != null && drawerContent.content}
					title={drawerContent != null && drawerContent.title}
					subtitle={drawerContent != null && drawerContent.subtitle}
				/>
			</div>
		</LandingAnimation>
	);
};
